import React from "react";
import ViewModelV2 from "./view_model";

export function ViewControllerV2<Props, VM extends ViewModelV2>(Context?: React.Context<VM>) {
    abstract class ViewControllerV2 extends React.Component<Props> {
        viewModel: VM;
    
        constructor(props: Props, viewModel: VM) {
            super(props);
            this.viewModel = viewModel;
            this.viewModel.renderVc = () => this.forceUpdate();
        }
    
        abstract build(): JSX.Element;
    
        render(): React.ReactNode {
            if (Context) {
                return <Context.Provider value={this.viewModel}>
                    { this.build() }
                </Context.Provider>;
            }

            return this.build();
        }
    }

    return ViewControllerV2;
}